import { render, staticRenderFns } from "./BankTransactionView.vue?vue&type=template&id=f79e2948&"
import script from "./BankTransactionView.vue?vue&type=script&lang=js&"
export * from "./BankTransactionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports